var render, staticRenderFns
import script from "./ChartPie.vue?vue&type=script&lang=js"
export * from "./ChartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1346bde7')) {
      api.createRecord('1346bde7', component.options)
    } else {
      api.reload('1346bde7', component.options)
    }
    
  }
}
component.options.__file = "src/views/chartStatistical/chart/ChartPie.vue"
export default component.exports